import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";

import { ModalContext } from "../../context/modal";
import { authApi } from "../../services/api";
import { DefaultButton, MyModalBody } from "../../style/default";

import { Loading } from "../../components/Loading";
import { TOASTIFY_OPTIONS } from "../../style/global";
import { DeleteFromApi } from "./styles";

function ModalDeleteTemplate({
	open,
	data,
	selectedAccount,
	selectedStatus,
	populateTable,
}) {
	const { handleOpenModal } = useContext(ModalContext);

	const [isLoading, setIsLoading] = useState(false);
	const [deleteAPI, setDeleteAPI] = useState(false);

	const handleDisableTemplate = async (item) => {
		try {
			setIsLoading(true);
			await authApi.post("/template/disable", {
				accountId: item.accountId,
				id: item._id,
				deleteAPI,
			});
			toast.success(
				"Template desabilitado e rejeitado com sucesso!",
				TOASTIFY_OPTIONS
			);
			populateTable(selectedAccount.value, selectedStatus.value);
			handleOpenModal();
		} catch (error) {
			toast.error(
				"Não foi possível desabilitar e rejeitar o template",
				TOASTIFY_OPTIONS
			);
		}
		setIsLoading(false);
	};

	return (
		<Modal show={open} onHide={handleOpenModal} size="lg" backdrop="static">
			{isLoading ? <Loading /> : null}
			<Modal.Header closeLabel="" closeButton>
				<Modal.Title>Desativar e rejeitar template: {data?.name}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<MyModalBody>
					Deseja realmente desativar e rejeitar o template: {data?.name}
					<DeleteFromApi>
						<div>
							<label htmlFor="delete-api">
								Deseja também deletar o template na API?
							</label>
							<input
								type="checkbox"
								id="delete-api"
								checked={deleteAPI}
								onChange={(e) => setDeleteAPI(e.target.checked)}
							/>
						</div>
						<span className="warning">
							Atenção: a ação de deletar o template na API é IRRECUPERÁVEL!
						</span>
					</DeleteFromApi>
				</MyModalBody>
			</Modal.Body>
			<Modal.Footer>
				<DefaultButton
					onClick={() => {
						handleDisableTemplate(data);
					}}
				>
					Ok
				</DefaultButton>
			</Modal.Footer>
		</Modal>
	);
}

export { ModalDeleteTemplate };
